import { FC } from "react";
import { Button, Tooltip } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { ThunkDispatch } from "@reduxjs/toolkit";
import {
  setColumnsToExport,
  setExportModalVisible,
} from "../../../../../../redux/slices/dataTable/dataExport";
import { ColumnsDataTable } from "../../../../../../redux/actions/dataTable/DataTableTypes";
import { State } from "../../../../../../redux/slices";
import { selectExportDataState } from "../../../../../../redux/selectors/unifiedSelectors";

export interface ButtonMenuDataTableProps {
  loading: boolean;
  disabled?: boolean;
}

const SetActions = () => {
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();

  return {
    setExportModalValues: (
      visible: boolean,
      columnsToExport: ColumnsDataTable[] | undefined,
      filtersToExport: any
    ) => {
      dispatch(setExportModalVisible(visible));
      dispatch(setColumnsToExport({ columnsToExport, filtersToExport }));
    },
  };
};

export const ExportButton: FC<ButtonMenuDataTableProps> = ({
  loading,
  disabled = false,
}) => {
  const [t] = useTranslation("global");


  const {
    columns,
    columnsVisibility,
    dataDateActivity,
    filterActions,
    filtersSpecies,
    filterUsers,
    filtersLocation,
  } = useSelector(selectExportDataState);

  const columnsToExport = columns?.reduce(
    (acc: any, column: ColumnsDataTable) => {
      if (columnsVisibility?.[column.field] && column.field !== "id") {
        acc.push({
          name: column.field,
          columnType: column.columnType,
          localizedName: column.headerName,
          hidden: false,
        });
      }
      return acc;
    },
    []
  );

  const filtersToExport = {
    datesRange: {
      fromDate: dataDateActivity[0],
      toDate: dataDateActivity[1],
    },
    cropsTextIds: filtersSpecies,
    scenarioNamesTextIds: filterActions,
    usernames: filterUsers,
    geoPointNames: filtersLocation,
  };

  const { setExportModalValues } = SetActions();

  return (
    <div>
      <Tooltip title={t("Data.Export_all")} arrow>
        <Button
          disabled={loading || disabled}
          onClick={() =>
            setExportModalValues(true, columnsToExport, filtersToExport)
          }
          sx={{ marginRight: "4px", textTransform: "none" }}
          size="medium"
          variant="contained"
        >
          <DownloadIcon sx={{ marginRight: "5px", fontWeight: 500 }} />
          <div className="mr-1" style={{ fontWeight: 600, fontSize: "15px" }}>
            {t("Data.table.Export")}
          </div>
        </Button>
      </Tooltip>
    </div>
  );
};
